










































































import { defineComponent, onMounted, computed, ref, watch, onBeforeUnmount } from 'vue-demi';
//@ts-ignore
import theme from '@zk/theme/lib/variables.scss';
import { useInstance } from 'common-module/src/util/useInstance';
import OverseasGuideTaskList, { taskOption } from './OverseasGuideTaskList.vue';
import { OverseasGuideDriver } from './driver';
import FeatureGuide from '@/pages/welcome/__components__/FeatureGuide.vue';
import { guideRecord, getSprintList } from '@/api/overseasGuide';
import { OverseasGuideDriverConfig } from './driver/overseasDriverConfig';
import { useI18n } from 'common-module/src/util/useI18n';
import { startRecorderUserGuide } from '@/components/float-btn/recorder/guide/newUserGuide';
// import { useHighLightElement } from './highLightElement/useHighLightElement';
import { startSubtaskGuide } from './driver/generatorSubtaskGuide';
import { startAiCommentSummaryGuide } from './driver/aiCommentSummaryGuide';
import { userHabitQuery, userHabitRecord } from '@/api/user';
import { isNil } from 'lodash';

const TASK_FINISH_STATUS = 10;
const CLOSE_GUIDE_TASK = 27;
const NEED_CHECK_PROJECT_TASK_CODES = ['CREATE_ISSUE', 'REFINE_FIELD_LAYOUT', 'FILTER_IMPORTANT_TASKS'];
const PRODUCT_OWNER_CODE = 'PRODUCT_MANAGER';
const FILTER_IMPORTANT_TASKS_AND_CREATE_SPRINT = 'FILTER_IMPORTANT_TASKS_AND_CREATE_SPRINT';

const RECORDER_TASK_CODES = ['USE_SCREEN_RECORD_TO_REPORT_BUG', 'USE_SCREEN_RECORD_SHARE_YOUR_IDEAS', 'EXTRACT_VOICE_FROM_VIDEO_FOR_CRITICAL_INFORMATION', 'CHECK_SCREEN_RECORD'];

export default defineComponent({
  name: 'OverseasGuideTaskCenter',
  bemNS: theme.bemNS,
  components: {
    OverseasGuideTaskList,
    FeatureGuide
  },
  props: {

  },
  socketEvents: {
    issueAdd(data: any){
      this.onIssueAdd(data);
    },
    'global:Project.detail'(data: any){
      this.onProjectCreate(data);
    }
  },
  setup() {

    const instance = useInstance();
    const { t } = useI18n();
    //const { startHighLightElement, destroy: destroyHighlightElement } = useHighLightElement();

    let currentDriver: any;

    const DEFAULT_TEXT = t('overseas.guide.task.defaultTitle');
    const FINISH_TEXT = t('overseas.guide.task.finishTitle');
    const FINISH_ALL_TEXT = t('overseas.guide.task.finishAllTitle');

    const viewPercentage = ref(0);

    const isTaskListShow = ref(false);

    const tipTxt = ref(DEFAULT_TEXT);

    const showFeatureGuideDialog = ref(false);

    let isWebImGuide: boolean | undefined;

    const account = computed(
      () => instance.$store.state.user.account
    );

    const currentProject = computed(
      () => instance.$store.state.app.currentProject
    );

    const projectList = computed(
      () => instance.$store.state.app.projectList || []
    );

    const currentAccountProjectList = computed(
      () => projectList.value.filter((i: any) => i.projectType !== 'DEMO_PROJECT' && i.createBy === account.value.userId)
    );

    const demoRecorderData = computed(
      () => instance.$store.state.overseasGuide.screenRecorderDemoData
    );

    const demoSubtaskData = computed(
      () => instance.$store.state.overseasGuide.SubtaskDemoData
    );

    const demoProject = computed(
      () => projectList.value.find((i: any) => i.projectType === 'DEMO_PROJECT')
    );

    const closeAll = ref(false);

    const chooseGuideProjectId = computed(
      () => {
        if (!currentAccountProjectList.value?.length){
          if (demoProject.value){
            return demoProject.value.id;
          }
          return projectList.value[0].id;
        }
        const isCurrentProjectInAccount = currentAccountProjectList.value.some((item: any) => item.id === currentProject.value);
        if (isCurrentProjectInAccount) {
          return currentProject.value;
        }
        return currentAccountProjectList.value[0].id;
      }
    );

    const refreshGuideTask = async() => {
      await instance.$store.dispatch('overseasGuide/getGuideInfo');
    };

    const taskList = computed(() => {
      return instance.$store.state.overseasGuide.guideTaskList || [];
    });

    const unFinishedTask = computed(() => {
      return taskList.value.filter((item: any) => {
        return item.questStatus === 0;
      });
    });

    const unFinishedTaskNum = computed(() => {
      return unFinishedTask.value.length;
    });

    const unFinishedTaskCodes = computed(() => {
      return unFinishedTask.value.map((item: any) => item.questCode);
    });

    const isTaskCenterHasClosed = computed(
      () => instance.$store.getters['guide/isDoneGuideByType'](CLOSE_GUIDE_TASK)
    );

    const showTaskCenter = computed(
      () => taskList.value.length && !isTaskCenterHasClosed.value && !closeAll.value
    );

    const percentage = computed(() => {
      const totalTaskNum = taskList.value.length;
      const finishedTaskNum = totalTaskNum - unFinishedTaskNum.value;
      return Math.floor(finishedTaskNum / totalTaskNum * 100);
    });

    const isProductOwner = computed(
      () => {
        const { roleVoList } = instance.$store.state.overseasGuide.guideRecommendData;
        return roleVoList?.some((item:any) => item.code === PRODUCT_OWNER_CODE);
      }
    );

    const clickFinishSelectorCodes = computed(
      () => {
        return Object.keys(OverseasGuideDriverConfig).filter(
          key => OverseasGuideDriverConfig[key].triggerFinish && unFinishedTaskCodes.value.includes(OverseasGuideDriverConfig[key].key)
        ).map(code => {
          const item = OverseasGuideDriverConfig[code];
          return {
            taskCode: item.key,
            selector: item.steps[item.steps.length - 1].selector
          };
        });
      }
    );

    watch(
      () => percentage.value,
      (newVal, oldValue) => {
        console.log('newVal', newVal, 'percentage.value');
        if (isTaskListShow.value){
          if (newVal){
            viewPercentage.value = newVal;
          }
          if (newVal > oldValue){
            tipTxt.value = FINISH_TEXT;
            if (newVal === 100){
              tipTxt.value = FINISH_ALL_TEXT;
            }
          }
        }
        if (newVal > oldValue && newVal === 100){
          // startHighLightElement({
          //   highLightSelector: '.zk-left-aside:not(.is-collapse) .zk-left-menu-item[data-menu="project"] >div',
          //   title: t('overseasGuide.create_project0.title'),
          //   description: t('overseasGuide.highlightProjectMenu.desc'),
          //   onCancel: () => {
          //     instance.$track.send('Guide_CreateProject', { 'position': 'close' }, true);
          //   },
          //   onHighlightClick: (e: any) => {
          //     const addProjectIconEl = document.querySelector('.zk-left-aside__add-p');
          //     if (addProjectIconEl && addProjectIconEl.contains(e.target as Element)) {
          //       instance.$track.send('Guide_CreateProject', { 'position': 'create' }, true);
          //     } else {
          //       instance.$track.send('Guide_CreateProject', { 'position': 'project_list' }, true);
          //     }
          //   }
          // });
          instance.$track.send('Guide_FinishTask', {}, true);
        }
      }
    );

    watch(
      () => isTaskListShow.value,
      (newVal) => {
        if (newVal) {
          tipTxt.value = DEFAULT_TEXT;
          setTimeout(
            () => {
              viewPercentage.value = percentage.value;
            },
            400
          );
        } else {
          viewPercentage.value = 0;
        }
      }
    );

    const toggleShow = () => {
      isTaskListShow.value = !isTaskListShow.value;
    };

    const handleClickOutside = async () => {
      //isTaskListShow.value = false;

    };

    const startDriver = (code: string, instance: any, pid?: number) => {
      currentDriver = new OverseasGuideDriver(code, instance, pid);
      currentDriver.start();
    };

    function startInitGuide() {
      const GUIDE_CODE = 'MEET_MY_AI_ASSISTANT_REPORT';
      const taskIndex = taskList.value.findIndex((item: any) => item.questCode === GUIDE_CODE);
      if (taskIndex <= -1) {
        return;
      }
      const task = taskList.value[taskIndex];
      if (task.questStatus === TASK_FINISH_STATUS){
        return;
      }
      //isTaskListShow.value = true;
      setTimeout(() => {
        handleTaskClick(task, taskIndex);
      }, 500);

    }

    const init = async () => {
      refreshGuideTask();
    };

    const getHasNoSprintData = async (pid: number) => {
      const hasOpenSprint = instance.$store.getters['features/isProjectSwitch']('module_sprint_switch', pid);
      if (!hasOpenSprint){
        return false;
      }
      const result = await getSprintList({
        pageNum: 1,
        pageSize: 10,
        projectId: pid,
        loadFinishCount: true,
        statusList:[]
      });
      return !result?.list?.length;
    };


    const handleTaskClick = async (item: taskOption, index: number) =>{
      if (item.questStatus === TASK_FINISH_STATUS){
        console.log('Task has finished');
      }
      console.log('Task start==========');
      //destroyHighlightElement();
      instance.$track.send('Guide_Task', {
        task_name: item.questName,
        task_order: index + 1,
        finish: item.questStatus === TASK_FINISH_STATUS
      }, true);
      if (RECORDER_TASK_CODES.includes(item.questCode)){
        startRecorderUserGuide(item.questCode, item.questName, demoRecorderData.value);
        return;
      }
      if (item.questCode === 'GENERATE_SUBTASKS_BY_AI') {
        startSubtaskGuide(item.questCode, item.questName, demoSubtaskData.value);
        return;
      }
      if (item.questCode === 'EXTRACT_INSIGHTS_FROM_LONG_COMMENTS') {
        startAiCommentSummaryGuide(item.questCode, item.questName, demoRecorderData.value);
        return;
      }
      let pid = chooseGuideProjectId.value;
      if (NEED_CHECK_PROJECT_TASK_CODES.includes(item.questCode)){
        if (item.questCode === 'FILTER_IMPORTANT_TASKS'){

          const isHasNoSprintData = await getHasNoSprintData(pid);
          if (isHasNoSprintData) {
            return startDriver(FILTER_IMPORTANT_TASKS_AND_CREATE_SPRINT, instance, pid);
          }
        } else {
          pid = pid === currentProject.value ? undefined : pid;
        }
      }
      startDriver(item.questCode, instance, pid);
    };

    const finishTask = (taskCode: string) => {
      instance.$store.dispatch('overseasGuide/finishTask', taskCode);
      if (unFinishedTaskCodes.value.includes(taskCode)) {
        const taskName = unFinishedTask.value.find((item: any) => item.questCode === taskCode)?.questName;
        instance.$track.send('Guide_OneTaskDone', { task_name: taskName }, true);
      }
    };

    const onIssueAdd = (data: any) => {
      if (account.value?.userId === data.createByVO?.id) {
        finishTask('CREATE_ISSUE');
      }
    };

    const onProjectCreate = (data: any) => {
      if (data?.action === 'add' && data?.msgType === 'Project.detail' && data.result?.projectVO?.createBy === account.value?.userId) {
        finishTask('CREATE_PROJECT');
      }
    };

    const onShowFeatureGuideDialog = () => {
      showFeatureGuideDialog.value = true;
    };

    const handleCloseTaskContainer = async () => {
      isTaskListShow.value = false;
      setTimeout(() => {
        closeAll.value = true;
        document.removeEventListener('click', handleDocumentClick, true);
        startDriver('FINISH_ALL_TASK_GUIDE', instance);
      }, 300);
      // destroyHighlightElement();
      await guideRecord(CLOSE_GUIDE_TASK);
      instance.$store.dispatch('guide/queryGuideInfo', true);
    };

    const onFinishTaskEventBus = (taskCode: string) => {
      if (taskCode === 'CREATE_ISSUE') {
        return;
      }
      finishTask(taskCode);
    };

    const handleDocumentClick = (e: MouseEvent) => {
      const selectors = clickFinishSelectorCodes.value.map(item => item.selector);
      if (!selectors.length){
        document.removeEventListener('click', handleDocumentClick);
        return;
      }
      selectors.forEach(selector => {
        const el = document.querySelector(selector);
        if (!el){
          return;
        }
        if (el.contains(e.target as Node)){
          const taskCode = clickFinishSelectorCodes.value.find(item => item.selector === selector)?.taskCode;
          if (taskCode){
            finishTask(taskCode);
          }
        }
      });
    };

    const onIssueReorderRecommendPopoverShow = (value: boolean) => {
      if (!currentDriver?.driver || !RECORDER_TASK_CODES.includes(currentDriver?.options?.key)) {
        return;
      }
      if (value) {
        currentDriver.toNextStep();
      }
      currentDriver.currentStep++;
      currentDriver.toNextStep();
    };

    const onGuideStart = () => {
      isTaskListShow.value = false;
    };

    const onGuideClose = () => {
      isTaskListShow.value = true;
    };

    const onRecorderUploaded = () => {
      const recorderCode = unFinishedTaskCodes.value.find((code: string) => RECORDER_TASK_CODES.includes(code));
      if (recorderCode) {
        finishTask(recorderCode);
        instance.eventBus.$off('recorder:uploaded', onRecorderUploaded);
      }
    };

    const onCloseIconClick = () => {
      toggleShow();
      instance.$track.send('Collapse_GuideList', { }, true);
    };

    const onMenuIconClick = () => {
      toggleShow();
      instance.$track.send('Click_GuideList', { action: isTaskListShow.value ? 'expand' : 'collapse' }, true);
    };

    const onSubtaskGenerateAction = () => {
      finishTask('GENERATE_SUBTASKS_BY_AI');
    };

    const onAiCommentSummarize = () => {
      finishTask('EXTRACT_INSIGHTS_FROM_LONG_COMMENTS');
    };

    async function queryWebImGuideHabit() {
      const res = await userHabitQuery({
        linkType: 'webImGuide',
        projectId: 0,
        userId: account.value?.userId
      });
      if (res && res.result.linkIdList?.length) {
        return !!res.result.linkIdList[0];
      }
    }

    function setWebIMGuideHabit(value: boolean) {
      return userHabitRecord({
        linkIdList: [value ? 1 : 0],
        linkType: 'webImGuide',
        projectId: 0,
        userId: account.value?.userId
      });
    }

    async function onVisible(visible: boolean) {
      if (!visible || isWebImGuide) {
        return;
      }
      if (isNil(isWebImGuide)) {
        isWebImGuide = await queryWebImGuideHabit();
        if (!isWebImGuide) {
          setWebIMGuideHabit(true);
          isWebImGuide = true;
          startInitGuide();
        } else {
          if (instance.$route.query.action === 'openWebIM') {
            instance.eventBus.$emit('global:openRobotChat', 'emailLink');
          }
        }
      }  
    }

    onMounted(
      () => {
        init();
        instance.eventBus.$on('overseasGuide:start', onGuideStart);
        instance.eventBus.$on('overseasGuide:close', onGuideClose);
        instance.eventBus.$on('finish-guide-task', onFinishTaskEventBus);
        instance.eventBus.$on('showVideo-highlights', onShowFeatureGuideDialog);
        instance.eventBus.$on('issue:recorder-recommend-popover-show', onIssueReorderRecommendPopoverShow);
        instance.eventBus.$on('recorder:uploaded', onRecorderUploaded);
        instance.eventBus.$on('subtask:generate-action', onSubtaskGenerateAction);
        instance.eventBus.$on('aiCommentSummarize:success', onAiCommentSummarize);
        document.addEventListener('click', handleDocumentClick, true);
      }
    );

    onBeforeUnmount(
      () => {
        instance.eventBus.$off('overseasGuide:start', onGuideStart);
        instance.eventBus.$off('overseasGuide:close', onGuideClose);
        instance.eventBus.$off('finish-guide-task', onFinishTaskEventBus);
        instance.eventBus.$off('showVideo-highlights', onShowFeatureGuideDialog);
        instance.eventBus.$off('issue:recorder-recommend-popover-show', onIssueReorderRecommendPopoverShow);
        instance.eventBus.$off('recorder:uploaded', onRecorderUploaded);
        document.removeEventListener('click', handleDocumentClick, true);
        instance.eventBus.$off('subtask:generate-action', onSubtaskGenerateAction);
        instance.eventBus.$off('aiCommentSummarize:success', onAiCommentSummarize);
      }
    );

    return {
      taskList,
      tipTxt,
      unFinishedTaskNum,
      isTaskListShow,
      showTaskCenter,
      viewPercentage,
      showFeatureGuideDialog,
      percentage,
      handleClickOutside,
      toggleShow,
      handleTaskClick,
      onIssueAdd,
      onProjectCreate,
      handleCloseTaskContainer,
      onCloseIconClick,
      onMenuIconClick,
      onVisible
    };


  }
});
